import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link, List } from '@one-thd/sui-atomic-components';
import { ArrowDown } from '@one-thd/sui-icons';
import { SalientListItem } from '../SalientListItem';
import { track } from '../../utils';

const pt = PropTypes;

// eslint-disable-next-line jsx-a11y/anchor-is-valid
const ViewMoreLink = ({ highlights, max, children, salientIconsTest }) => {
  const [isOpen, setIsOpen] = useState(false);
  const showMoreRef = useRef(false);

  const collapseClasses = classNames(
    'sui-transition-all',
    'sui-duration-228',
    'sui-ease-in-out',
    'sui-overflow-hidden',
    {
      'sui-max-h-48': isOpen,
      'sui-max-h-0': !isOpen
    }
  );

  const arrowClasses = classNames(
    'sui-ml-2',
    'sui-transition-transform',
    'sui-duration-225',
    {
      'sui-rotate-180': isOpen
    }
  );

  switch (salientIconsTest) {
    case 'hybrid':
      return (
        <div className="sui-w-fit xl:sui-w-full">
          <div className={collapseClasses}>
            <div className="sui-pb-4 sui-px-2 sui-bg-white">
              <List className="sui-text-base sui-list-disc sui-list-inside">
                {(highlights || []).slice(0, max).map((point, index) => (
                  <SalientListItem key={`highlight-${index}`} point={point} />
                ))}
                {children}
              </List>
            </div>
          </div>
          {(highlights && highlights.length > 0) && (
            <button
              // eslint-disable-next-line max-len
              className="sui-flex sui-text-base sui-items-center sui-w-full sui-p-2.5 sui-bg-white sui-border-0 sui-rounded-none sui-outline-none sui-relative sui-transition-all sui-duration-228 sui-ease-in-out sui-justify-center"
              type="button"
              onClick={() => {
                if (!isOpen && !showMoreRef.current) {
                  track('salient-points', 'click', { salientType: salientIconsTest });
                  showMoreRef.current = true;
                }
                setIsOpen(!isOpen);
              }}
              aria-expanded={isOpen}
            >
              {isOpen ? 'Show Less' : 'Show More'}
              <ArrowDown
                className={arrowClasses}
                width={16}
                height={16}
              />
            </button>
          )}
        </div>
      );
    case 'standard':
      return (children);
    default:
      return null;
  }
};

ViewMoreLink.propTypes = {
  highlights: pt.arrayOf(pt.string),
  max: pt.number.isRequired,
  children: pt.node,
  salientIconsTest: pt.string.isRequired
};
ViewMoreLink.defaultProps = {
  highlights: [],
  children: null,
};
export { ViewMoreLink };